module.exports = __webpack_public_path__ + "static/media/calendar-clock-white.d8daf381.svg";